import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const GenerateDealMutation
 * @since 1.0.0
 */
export const GenerateDealMutation = gql `
  mutation GenerateDealMutation($input: GenerateDealPdfInput!) {
    generateDealPdf(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
